import React from 'react';
import logo from "../assets/icons/logo.png";
import '../assets/css/Loader.css';

export const showLoader = () => {
  const loaderDiv = document.createElement('div');
  loaderDiv.setAttribute('id', 'global-loader');
  loaderDiv.innerHTML = `
    <div class="loader-overlay">
      <img src="${logo}" class="loader-logo" alt="Loading" />
    </div>
  `;
  document.body.appendChild(loaderDiv);
};

export const hideLoader = () => {
  const loaderDiv = document.getElementById('global-loader');
  if (loaderDiv) {
    document.body.removeChild(loaderDiv);
  }
};

const CustomLoader: React.FC = () => {
  return (
    <div className="loader-overlay">
      <img src={logo} className="loader-logo" alt="Loading" />
    </div>
  );
};

export default CustomLoader;
